import { useMemo } from 'react';
import { useSelectedStore } from '@/hooks';
import { KeyTextField } from '@prismicio/client';

/**
 * Hook to filter the items of a slice by the location_slug.
 */
const useFilteredSliceItemsByLocationSlug = items => {
  const { store } = useSelectedStore();

  const filteredItems = useMemo(() => {
    if (!Array.isArray(items)) return [];

    return items.filter(item => {
      if (!item?.location_slug || !store?.url_slug) return true;
      const slugs = item.location_slug.split(',').map(slug => slug.trim());
      return slugs?.includes(store?.url_slug);
    });
  }, [items, store]);

  return { filteredItems };
};

const useShowByLocationSlug = (locationSlug?: string | KeyTextField) => {
  const { store } = useSelectedStore();

  const showContent = useMemo(() => {
    if (!locationSlug || !store?.url_slug) return true;

    const slugs = locationSlug?.split(',').map(slug => slug.trim());

    return slugs?.includes(store?.url_slug);
  }, [locationSlug, store]);

  return { showContent };
};

export { useFilteredSliceItemsByLocationSlug, useShowByLocationSlug };
